import { useLang } from "../context/TranslationProvider";

export type DateKey = "YYYY-MM-DD";

export default function timeAgo(timestamp: string | number) {
  const { t } = useLang();

  let timeMs: number;

  if (typeof timestamp === "number") {
    // old unix seconds
    timeMs = timestamp * 1000;
  } else {
    // D1 CURRENT_TIMESTAMP (TEXT)
    timeMs = new Date(timestamp).getTime();
  }

  const now = Date.now();
  const diff = now - timeMs;

  const seconds = Math.floor(diff / 1000);
  if (seconds < 60) return `${seconds} ${t("sec_ago")}`;

  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes} ${t("min_ago")}`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} ${t("hrs_ago")}`;

  const days = Math.floor(hours / 24);
  if (days < 30) return `${days} ${t("days_ago")}`;

  const months = Math.floor(days / 30);
  if (months < 12) return `${months} ${t("months_ago")}`;

  const years = Math.floor(months / 12);
  return `${years} ${t("yrs_ago")}`;
}

export function minutesToTime(minutes: number, use12Hour = true): string {
  let hrs = Math.floor(minutes / 60);
  const mins = minutes % 60;

  let period = "";
  if (use12Hour) {
    period = hrs >= 12 ? " PM" : " AM";
    if (hrs > 12) hrs -= 12;
    if (hrs === 0) hrs = 12;
  }

  const hh = hrs.toString().padStart(2, "0");
  const mm = mins.toString().padStart(2, "0");

  return `${hh}:${mm}${period}`;
}

export function dateFormat(dateInput?: string | number | Date | null) {
  if (!dateInput) return "-"; // handle null/undefined

  const date = new Date(dateInput);
  if (isNaN(date.getTime())) return "-"; // handle invalid date

  // Format as YYYY-MM-DD HH:mm:ss
  const pad = (n: number) => n.toString().padStart(2, "0");

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * Convert Google Sheets / Excel serial date value to YYYY-MM-DD
 */
export function sheetDateValueToISO(
  dateValue: number | string | null | undefined
): string | null {
  if (dateValue == null) return null;

  const serial = Number(dateValue);
  if (Number.isNaN(serial)) return null;

  // Google Sheets / Excel base date
  const date = new Date(1899, 11, 30 + serial);

  if (isNaN(date.getTime())) return null;

  return date.toISOString().slice(0, 10); // YYYY-MM-DD
}

 